import { Button, useTheme } from "@mui/material";
import { authFlowHeaderIcons } from "./authFlowHeaderIcons";
import {
  getLoginPrimaryButtonSx,
  LoginCardContent,
  LoginFormHeader,
} from "./loginUi";

export type PasswordResetSentProps = {
  loginUrl?: string;
  translations: {
    resetPasswordSent: string;
    resetPasswordSentDescription: string;
    backToLogin: string;
  };
};

export const PasswordResetSent = ({
  loginUrl = "/accounts/login/",
  translations: t,
}: PasswordResetSentProps) => {
  const theme = useTheme();

  return (
    <LoginCardContent testId="password-reset-sent">
      <LoginFormHeader
        title={t.resetPasswordSent}
        subtitle={t.resetPasswordSentDescription}
        headerIcon={authFlowHeaderIcons.passwordResetSent}
        headerTestId="password-reset-sent-header"
        titleTestId="password-reset-sent-title"
        headerIconTestId="password-reset-sent-header-icon"
      />

      <Button
        href={loginUrl}
        fullWidth
        variant="contained"
        size="large"
        data-testid="back-to-login-button"
        sx={getLoginPrimaryButtonSx(theme)}
      >
        {t.backToLogin}
      </Button>
    </LoginCardContent>
  );
};
